import React, {useState} from 'react';
import styles from './Animation.module.css';

import can1 from '../../assets/can-mapple.png';
import abg1 from '../../assets/mapple-bg-1.png';
import abg2 from '../../assets/mapple-bg-2.png';

import can2 from '../../assets/can-pomape.png';
import bbg1 from '../../assets/pomape-bg-1.png';
import bbg2 from '../../assets/pomape-bg-2.png';

import can3 from '../../assets/can-grandc.png';
import cbg1 from '../../assets/grandc-bg-1.png';
import cbg2 from '../../assets/grandc-bg-2.png';

import can4 from '../../assets/can-fizzc.png';
import dbg1 from '../../assets/fizzc-bg-1.png';
import dbg2 from '../../assets/fizzc-bg-2.png';

import WaveTop from '../wave/WaveTop';
import WaveBottom from '../wave/WaveBottom';

const Animation = () => {
    const [bgColor, setBgColor] = useState("#FAEBCE");
    return (
        <div id="flavored" className={styles.supreme} style={{ backgroundColor: bgColor }}>
            <WaveTop />
        <div className={styles.parent}>
            <div className={styles.can}
            
  onMouseEnter={() => setBgColor("#EFB23B")}
  onMouseLeave={() => setBgColor("#FAEBCE")}>
                <div className={styles.img_wrapper}>
                    <img src={can1} className={styles.img1} alt="can1" />
                    <img src={abg1} className={styles.img2} alt="bg1" />
                    <img src={abg2} className={styles.img3} alt="bg2" />
                </div>
                <h3
                className={styles.head1}
                //  style={{color: "#F6C00E"}}
                >Mango and Pineapple</h3>
                <h5>INGREDIENTS:</h5>
                <p>Water, Sugar, Mango & Pineapple Juice, Acidity Regulators (E330, E331iii, E300), Stabilizers (E466, E415), Flavors, Salt, Sweeteners (E950, E955), Food Colors (E110, E160aii).</p>
            </div>
            <div className={styles.can}
            
  onMouseEnter={() => setBgColor("#64247A")}
  onMouseLeave={() => setBgColor("#FAEBCE")}>
                
                <div className={styles.img_wrapper}>
                    <img src={can2} className={styles.img1} alt="can1" />
                    <img src={bbg1} className={styles.img2} alt="bg1" />
                    <img src={bbg2} className={styles.img3} alt="bg2" />
                </div>
                <h3
                className={styles.head2}
                //  style={{color: "#DB1A1D"}}
                >Pomegranate and GRape</h3>
                <h5>INGREDIENTS:</h5>
                <p>Water, Sugar, Pomegranate & Grape Juice, Acidity Regulators (E330, E331iii), Stabilizers (E466, E415), Flavors, Salt, Sweeteners (E950, E955), Food Colors (E129, E133).</p>
            </div>
            <div
            className={styles.can}
            onMouseEnter={() => setBgColor("#3E8412")}
            onMouseLeave={() => setBgColor("#FAEBCE")}
            >
                
                <div className={styles.img_wrapper}>
                    <img src={can3} className={styles.img1} alt="can1" />
                    <img src={cbg1} className={styles.img2} alt="bg1" />
                    <img src={cbg2} className={styles.img3} alt="bg2" />
                </div>
                <h3 
                className={styles.head3}
                // style={{color: "#A954DD"}}
                >GRape AND Calamansi</h3>
                <h5>INGREDIENTS:</h5>
                <p>Water, Sugar, Blackcurrant & Calamansi Juice, Acidity Regulators (E330, E331iii), Stabilizers (E466, E415), Flavors, Salt, Sweeteners (E950, E955), Food Colors (E150c, E129).</p>
            </div>
            <div className={styles.can}
            
  onMouseEnter={() => setBgColor("#D6710E")}
  onMouseLeave={() => setBgColor("#FAEBCE")}>
                
                <div className={styles.img_wrapper}>
                    <img src={can4} className={styles.img1} alt="can1" />
                    <img src={dbg1} className={styles.img2} alt="bg1" />
                    <img src={dbg2} className={styles.img3} alt="bg2" />
                </div>
                <h3 
                className={styles.head4}
                // style={{color: "#EA7D1A"}}
                >ORANGE and Peach</h3>
                <h5>INGREDIENTS:</h5>
                <p>Water, Sugar, Orange & Peach Juice, Acidity Regulators (E330, E331iii), Stabilizers (E466, E415), Flavors, Salt, Sweeteners (E950, E955), Food Color (E110).</p>
            </div>
        </div>
        <WaveBottom />
        </div>
    )
}

export default Animation;